<template>
  <div class="home container">
    
      <div class="row">
            <!-- <div class="col-md-3 d-none d-md-block">
                <SideBar/>
            </div> -->
            <div class="col-md-12 home-main">
             
              <div class="row home-info">
                <div class="col-12 col-xl-12 d-none d-lg-block">
                    <h1 id="home-hero">Enhance Your <br> Staff Wellbeing!</h1>
                    <p class="mb-2 ">My Healthy Staff gives you a full range of training 
                        options to ensure the mental and physical well-being of your staff.</p>
                    <p class="mt-0 mb-md-4 mb-xl-0 pb-0">Give your staff key information on subjects that matter in an 
                        informative and non-judgmental way</p>
                </div>
                
              </div>
              <div class="m-block mt-2 d-lg-none d-block">
                  <div class="col-12">
                    <p>Enhance Your <br/>Staff Wellbeing!</p>
                  </div>
              </div>
              <section class="row home-tiles mt-3">
                  <div class="col-6 col-xl-2 titles-flex">
                    <router-link to="/shop/mental-health" class="tile">
                      <img :src="cdn+'/images/mental-health.png'" alt="Mental Health">
                      <h2>Mental <br/>Health</h2>
                    </router-link>
                  </div>
                  <div class="col-6 col-xl-2 titles-flex">
                    <router-link to="/shop/personal-safety" class="tile">
                        <img :src="cdn+'/images/personal-safety.png'" alt="Personal Safety">
                      <h2>Personal <br/>Safety</h2>
                    </router-link>
                  </div>
                  <div class="col-6 col-xl-2 titles-flex">
                    <router-link to="/shop/manual-handling" class="tile">
                        <img :src="cdn+'/images/manual-handling.png'" alt="Manual Handling">
                      <h2>Manual <br/>Handling</h2>
                    </router-link>
                  </div>
                  <div class="col-6 col-xl-2 titles-flex">
                    <router-link to="/shop/fire-safety" class="tile">
                     <img :src="cdn+'/images/fire-safety.png'" alt="Fire Safety">
                      <h2>Fire <br/>Safety</h2>
                    </router-link>
                  </div>
                  <div class="col-6 col-xl-2 titles-flex">
                    <router-link to="/shop/computer-safety" class="tile">
                       <img :src="cdn+'/images/computer-safety.png'" alt="Computer Safety">
                      <h2>Computer <br/>Safety</h2>
                    </router-link>
                  </div>
                  <div class="col-6 col-xl-2 titles-flex">
                    <router-link to="/shop/office-safety" class="tile">
                       <img :src="cdn+'/images/office-safety.png'" alt="Office Safety">
                      <h2>Office <br/>Safety</h2>
                    </router-link>
                  </div>
                  <div class="col-6 col-xl-2 titles-flex">
                    <router-link to="/shop/disability-awareness" class="tile">
                       <img :src="cdn+'/images/disability-awareness.png'" alt="Disability Awareness">
                      <h2>Disability <br>Awareness</h2>
                    </router-link>
                  </div>
                  <div class="col-6 col-xl-2 titles-flex">
                    <router-link to="/shop/drink-drug-awareness" class="tile">
                      <img :src="cdn+'/images/drink-drug-awareness.png'" alt="Alcohol / Drug Awareness">
                      <h2>Alcohol / Drug <br>Awareness</h2>
                    </router-link>
                  </div>
                  <div class="col-6 col-xl-2 titles-flex">
                    <router-link to="/shop/home-working" class="tile">
                      <img :src="cdn+'/images/home-working-221.jpg'" alt="Home Working">
                      <h2>Home <br> Working</h2>
                    </router-link>
                  </div>
                  <div class="col-6 col-xl-2 titles-flex">
                    <router-link to="/shop/first-aid" class="tile">
                      <img :src="cdn+'/images/Fist-Aid-221.jpg'" alt="First Aid">
                      <h2>First <br> Aid</h2>
                    </router-link>
                  </div>
              </section>
              <section class="row home-hero">
                  <div class="col-md-6 box py-0">
                      <router-link to="/training-course/emotional-resilience-classroom-training" class="nav-link p-0 pr-md-2">
                        <img :src="cdn+'/images/emotional-resilience-advert.jpg'" alt="Emotion Resilience">
                      </router-link>
                  </div>
                  <div class="col-md-6 box py-0">
                      <router-link to="/elearning/homeworking-helpful-tips" class="nav-link p-0 pl-md-2">
                        <img :src="cdn+'/images/Homeworking-advert.jpg'" alt="Home Working">
                      </router-link>
                  </div>
              </section>
            </div>
        </div>    
  </div>
</template>

<script>
// @ is an alias to /src
import SideBar from '../components/sidebar.vue';
export default {
  name: 'home',
  data(){
    return {
       cdn: process.env.VUE_APP_CDN_IMAGE_URL,
       }
  },
  components: {
    SideBar
  },
  mounted(){
    if(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && this.$route.name == 'home'){
      $('#body').addClass("mob-body-home");
      //$('#nav').show();
    }    
  },
  methods:{
    get_video_type(){
      let video_extention ='mp4';
      if(typeof InstallTrigger !== 'undefined'){
        video_extention = 'ogg';
      }
      return video_extention;
    }
  }
}
</script>

<style lang="scss">
.home-main{
  .home-info{
    p{
        color: #333;
        text-align: left;
    }
    #home-hero{
        text-align: center;
        font-size: 32px;
        margin-top: 0;
        color: #3f3f3f;
        font-weight: 600;
    }

    
    .home-video iframe {
      min-height: 200px;
      overflow: hidden;

      @media all and (max-width: 1199px) {
        height: 300px;
      }
      @media all and (max-width: 1024px) {
        height: 282px;
      }
      @media all and (max-width: 767px) {
        height: 250px;
      }
      @media all and (max-width: 450px) {
        min-height: 190px;
        height: 190px;
      }
    }
  }

  .divider {
    border-top: thin solid #333;
    margin-bottom: 16px;
  }

  .home-hero{
    .box{
        text-transform: capitalize;
        margin-bottom: 16px;
        img{
              // max-height: 160px;
              width: auto;
              margin-bottom: 0;
        }
        h2{
          font-weight: 600;
		  font-size: 1.1rem !important;
          color: #3f3f3f;
          margin: 16px 0;
        }
        p{
          color: #e3342f;
          font-size: 16px;
        }
    }
    .box > *{
        display: block;
    }
  }
  .hsg h2{
      font-weight: 600;
	  font-size: 1.1rem !important;
      color: #3f3f3f;
  }
}
@media(max-width: 575px){
  .home-hero{
    .box{
      a{
        background: white;
      }
    }
  }
  .home-info
  {
    iframe{
      height: 100%;
      width: 100%;
    }
  }
  .home-main{
    margin-top: 24px;
    padding: 0;
  }

  .box:first-child{
      padding-right: 15px !important;
    }
    .box:nth-child(2) {
        padding-left: 15px !important;
    }
    .home-main .home-hero .box{
      text-align: center;
    h2{
	  font-size: 1.1rem !important;
    }
    p{
      font-size: 19px;
    }
    }
}
</style>



